

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { SchoolFormComponent } from '../schools/school-form/school-form.component';
import { AddYearComponent } from './add-year/add-year.component';
import { EditYearComponent } from './edit-year/edit-year.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';


@Component({
  selector: 'app-academic-year',
  templateUrl: './academic-year.component.html',
  styleUrls: ['./academic-year.component.scss']
})
export class AcademicYearComponent implements OnInit {
  @ViewChild('PRINT_TABLE', { static: false }) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.ACADEMIC_YEAR;
  NO_AVATAR = 'https://firebasestorage.googleapis.com/v0/b/sysanotta.appspot.com/o/no_image.svg?alt=media&token=f25af902-6c62-47e6-bdf3-48e3b0c6fe8c'

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public store: BookstoreStore,
    public ps: PrintService,
    private storage: FireStorageService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public env:AuthStore
  ) { }

  ngOnInit() {
    this.store.fetchAcademicYear()
  }

  ngOnDestroy() {
    const { fetchAcademicYearRef } = this.store;
    fetchAcademicYearRef && fetchAcademicYearRef.unsubscribe();
  }

  create() {
    const dialogRef = this.dialog.open(AddYearComponent, {
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }


  edit(item?: any) {
    const dialogRef = this.dialog.open(EditYearComponent, {
      data: item || null,
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    // let dialogRef = this.dialog.open(DeleteComponent, {
    //   data: { title: 'Delete Book', memo: 'Document will delete from you and student.', name: item.name },
    //   width: '35vw',
    //   disableClose: true,
    //   role: 'dialog',
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result === 'yes') {
    //     try {
    //       const { photoFileDetail } = item;
    //       if (photoFileDetail.filename) {
    //         this.storage.storageRef(photoFileDetail.filename).delete();
    //       }
    //     } catch (error) {
    //     }
    //     this.store.deleteItem(COLLECTION_NAME.STUDENTS, item, (success, res) => {
    //       this.snackBar.open("Member has been deleted successful.", "Done", { duration: 1000 });
    //     })
    //   }
    // });
  }

  activeTerm(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Active Academic Year', memo: 'This term year will change to active and old term will close', name: item.name, button:'active' },
      width: '680px',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.activeTerm(item, this.env.user, (success, error) => {
          if (success) {
            this.snackBar.open('Academic Year has been active.', 'done', { duration: 2000 });
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }


}
